'use strict';

var Carousel = require('./lib/carousel');

module.exports = Carousel;



//////////////////
// WEBPACK FOOTER
// ./~/nuka-carousel/index.js
// module id = 143
// module chunks = 35783957827783 43201937662106